import { supabase } from '../lib/supabase';

/**
 * Partner Service
 * Manages affiliate and rev-share partners
 */

/**
 * Get all active partners
 */
export const getPartners = async () => {
    try {
        const { data, error } = await supabase
            .from('partners')
            .select(`
        *,
        category:knowledge_base_categories(name, slug)
      `)
            .eq('is_active', true)
            .order('name');

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error fetching partners:', error);
        return { data: null, error };
    }
};

/**
 * Get partners for a specific category
 */
export const getPartnersByCategory = async (categoryId) => {
    try {
        const { data, error } = await supabase
            .from('partners')
            .select('*')
            .eq('category_id', categoryId)
            .eq('is_active', true);

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error fetching category partners:', error);
        return { data: null, error };
    }
};

/**
 * Admin: Add a new partner
 */
export const addPartner = async (partnerData) => {
    try {
        const { data, error } = await supabase
            .from('partners')
            .insert([partnerData])
            .select()
            .single();

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error adding partner:', error);
        return { data: null, error };
    }
};

/**
 * Admin: Update a partner
 */
export const updatePartner = async (partnerId, updates) => {
    try {
        const { data, error } = await supabase
            .from('partners')
            .update(updates)
            .eq('id', partnerId)
            .select()
            .single();

        if (error) throw error;
        return { data, error: null };
    } catch (error) {
        console.error('Error updating partner:', error);
        return { data: null, error };
    }
};

/**
 * Admin: Delete a partner (or deactivate)
 */
export const deletePartner = async (partnerId, deletePermanent = false) => {
    try {
        if (deletePermanent) {
            const { error } = await supabase
                .from('partners')
                .delete()
                .eq('id', partnerId);
            if (error) throw error;
        } else {
            const { error } = await supabase
                .from('partners')
                .update({ is_active: false })
                .eq('id', partnerId);
            if (error) throw error;
        }
        return { error: null };
    } catch (error) {
        console.error('Error deleting partner:', error);
        return { error };
    }
};

export default {
    getPartners,
    getPartnersByCategory,
    addPartner,
    updatePartner,
    deletePartner,
};
